export default "__VITE_ASSET__CpDsS1XL__"